import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=f9bedf7e&"
import script from "./Remark.controller.js?vue&type=script&lang=js&"
export * from "./Remark.controller.js?vue&type=script&lang=js&"
import style0 from "./Remark.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports